var React = require('react');

function IconUpgrade (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Upgrade"),React.createElement("g",{"fill":"currentColor","fillRule":"nonzero","key":1},[React.createElement("path",{"d":"M8 22a1 1 0 1 1 0 2H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4h-4a1 1 0 0 1 0-2h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4z","key":0}),React.createElement("path",{"d":"M11 8.388l-4.29 4.317a1 1 0 1 1-1.42-1.41l6.516-6.555 6.553 6.553a1 1 0 0 1-1.414 1.414L13 8.762V23a1 1 0 0 1-2 0V8.388z","key":1})])]);
}

IconUpgrade.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconUpgrade;

IconUpgrade.default = IconUpgrade;
